var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.65,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.9,
    cy: 4.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M8.1 8.1l4.3 4.3"
  }))));
};
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTMgMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS42NSIgZmlsbD0ibm9uZSI+CiAgICA8Y2lyY2xlIGN4PSI0LjkiIGN5PSI0LjkiIHI9IjMuOSIvPgogICAgPHBhdGggc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZD0iTTguMSA4LjFsNC4zIDQuMyIvPgogIDwvZz4KPC9zdmc+";